import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 bg-green-50 border-y border-green-100" data-id="element-58" data-mp="4w1i6y7thelh">
      <div className="container mx-auto px-4" data-id="element-59" data-mp="9ttj2hqfwb1t">
        <FadeIn data-id="element-60" data-mp="9t1nh6wuedbj">
          <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-61" data-mp="9wpfu2qjwtoo">
            <div className="shrink-0" data-id="element-62" data-mp="jssh76dkwoak">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center" data-id="element-63" data-mp="jrr837g4ibvh">
                <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-64" data-mp="nst65kyb0hvv" />
              </div>
            </div>
            <div data-id="element-65" data-mp="sldzymh7muze">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-66" data-mp="smxfgav1l204">
                Garantía "Sin Vueltas" de 7 Días. ✅
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed" data-id="element-67" data-mp="12jthbxqfqpvp">
                Probá el pack completo. Si en 7 días sentís que no es para vos,
                nos escribís y te devolvemos el 100% de tu dinero. Sin
                preguntas, sin riesgos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}